import { TimerIconWhite } from 'assets/icons';
import React, { useEffect, useState } from 'react';
import './styles.scss';

interface Props {
	deadlineDate: any;
	description: string;
}
const CountdownTimer: React.FC<Props> = ({ deadlineDate, description }) => {
	const [days, setDays] = useState(0);
	const [hours, setHours] = useState(0);
	const [minutes, setMinutes] = useState(0);

	const getTimeUntil = (deadlineDate: string) => {
		const time = Date.parse(deadlineDate) - new Date().getTime();

		if (time <= 0) {
			return {
				days: 0,
				hours: 0,
				minutes: 0,
			};
		}

		setMinutes(Math.floor((time / 1000 / 60) % 60));
		setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
		setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
	};

	useEffect(() => {
		getTimeUntil(deadlineDate);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setInterval(() => getTimeUntil(deadlineDate), 1000);
	}, [deadlineDate]);

	return (
		<>
			<div className="CountdownTimer">
				<span className="CountdownTimer__description">{description}</span>
				<div className="CountdownTimer__box">
					<TimerIconWhite className="CountdownTimer__icon" />
					<div className="CountdownTimer__timerText">
						<span className="CountdownTimer__values">{days}d</span>
					</div>
					<div className="CountdownTimer__timerText">
						<span className="CountdownTimer__values">{hours}h</span>
					</div>
					<div className="CountdownTimer__timerText">
						<span className="CountdownTimer__values">{minutes}min</span>
					</div>
				</div>
			</div>
		</>
	);
};

export default CountdownTimer;
